import { useNavigation } from '@remix-run/react';
import { cn } from '@theprintbar/shared';
import React from 'react';

export const Spinner: React.FC<{ className?: string }> = ({ className }) => (
	<svg className={cn('animate-spin text-white', className)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
		<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
		<path
			className="opacity-75"
			fill="currentColor"
			d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
		/>
	</svg>
);

export function PageLoadingSpinner({ show }: { show?: boolean }) {
	const navigating = useNavigation().state === 'loading';

	return navigating || show ? (
		<div className="fixed inset-0 flex items-center justify-center bg-black/20 z-[9999]">
			<Spinner className="absolute top-8 right-8 w-6 h-6" />
		</div>
	) : null;
}

export default Spinner;
